import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ExternalLink, ArrowRight } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import { api, getMl, fileUrl } from "@/lib/api";

const News = () => {
  const { t, lang } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/news").then((r) => setItems(r.data));
  }, []);

  const titles = { en: "News & Insights", tr: "Haberler & Görüşler", id: "Berita & Wawasan" }[lang];

  return (
    <div data-testid="news-page">
      <section className="bg-[#0A1128] text-white py-24 md:py-28">
        <div className="container-nakia">
          <div className="flex items-center gap-3 mb-5">
            <span className="gold-divider" />
            <span className="text-eyebrow text-[#D4AF37]">Insights</span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl">{titles}</h1>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="container-nakia">
          {items.length === 0 ? (
            <p className="text-center text-slate-500 py-20">{t("common.noResults")}</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((n) => (
                <Link
                  key={n.id}
                  to={`/news/${n.slug}`}
                  data-testid={`news-${n.slug}`}
                  className="card-light overflow-hidden flex flex-col group"
                >
                  {n.cover_image && (
                    <div className="aspect-[16/10] overflow-hidden relative">
                      <img
                        src={fileUrl(n.cover_image)}
                        alt=""
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                      {n.external_link && (
                        <div
                          className="absolute top-3 right-3 w-9 h-9 bg-[#D4AF37] flex items-center justify-center rounded-sm shadow-lg"
                          title="Has external source"
                        >
                          <ExternalLink size={14} className="text-[#0A1128]" />
                        </div>
                      )}
                    </div>
                  )}
                  <div className="p-7 flex-1 flex flex-col">
                    <div className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] mb-2">
                      {new Date(n.published_at).toLocaleDateString(lang)}
                    </div>
                    <h3 className="font-display text-xl text-[#0A1128] mb-3 group-hover:text-[#D4AF37] transition-colors">
                      {getMl(n.title, lang)}
                    </h3>
                    <p className="text-sm text-slate-600 line-clamp-3">{getMl(n.excerpt, lang)}</p>
                    <div className="mt-5 inline-flex items-center gap-2 text-[#0A1128] text-xs uppercase tracking-[0.2em] font-semibold border-t border-slate-100 pt-4">
                      {t("common.readMore")} <ArrowRight size={12} className="text-[#D4AF37]" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default News;
